// extracted by mini-css-extract-plugin
module.exports = {"videoSideBar":"VideoSidebar_videoSideBar__2AuA6","videoSideBar__button":"VideoSidebar_videoSideBar__button__1QsO3","rounded":"VideoSidebar_rounded__39q_c"};